import { useState } from "react";
import {
  Box,
  Paper,
  TextField,
  Typography,
  Button,
  InputAdornment,
  IconButton,
  Link,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import logoLogin from "../../static/logo_login.webp";
import { useApp } from "../../context/AppContext";

export default function Login() {
  const navigate = useNavigate();
  const { clearSession, setSession } = useApp();

  const [showPassword, setShowPassword] = useState(false);
  const [correo, setCorreo] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!correo || !password) {
      setError("Completa todos los campos");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("/login/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          correo,
          password,
        }),
      });

      let data;

      try {
        data = await res.json();
      } catch {
        throw new Error("Servidor no respondió correctamente");
      }

      if (!res.ok) {
        throw new Error(data.error || "Credenciales incorrectas");
      }

      setSession({
        access: data.access,
        refresh: data.refresh,
        user: data.user,
      });

      navigate("/admin", { replace: true });
    } catch (err) {
      setError(err.message || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  const handleBackHome = (e) => {
    e.preventDefault();
    clearSession();
    navigate("/", { replace: true });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        background: "#dcdcdc",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 420,
          p: 4,
          borderRadius: "18px",
          border: "1px solid rgba(140,15,44,0.18)",
        }}
      >
        <Box
          component="img"
          src={logoLogin}
          alt="logo login"
          sx={{
            height: 70,
            display: "block",
            mx: "auto",
            mb: 2,
          }}
        />

        <Typography
          align="center"
          sx={{
            fontSize: "1.4rem",
            fontWeight: 700,
            mb: 3,
            color: "primary.main",
          }}
        >
          Acceso Administrativo
        </Typography>

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            label="Correo"
            fullWidth
            error={Boolean(error)}
            sx={{ mb: 2 }}
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
          />

          <TextField
            label="Contraseña"
            type={showPassword ? "text" : "password"}
            fullWidth
            error={Boolean(error)}
            helperText={error}
            sx={{ mb: 1 }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end" type="button">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            fullWidth
            type="submit"
            variant="contained"
            disabled={loading}
            sx={{
              height: 44,
              mt: 2,
              borderRadius: "12px",
              fontWeight: 600,
              textTransform: "none",
            }}
          >
            {loading ? "Ingresando..." : "Iniciar sesión"}
          </Button>
        </Box>

        <Typography
          sx={{
            fontSize: "0.85rem",
            mt: 1,
            textAlign: "right",
          }}
        >
          <Link
            component="button"
            type="button"
            underline="hover"
            onClick={handleBackHome}
          >
            Volver al inicio
          </Link>
        </Typography>
      </Paper>
    </Box>
  );
}